/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Drawer, TextField, Grid, Typography } from '@mui/material'
import { LocalGasStation, HighlightOff } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { connect } from 'react-redux'
import * as online from '../../../../appRedux/actions/fuel_request/online'
import IntlMessages from '../../../../util/IntlMessages'
import useStyles from './record_literature.style'

function RecordLiterature(props) {
    const classes = useStyles()
    const [litrage, setLitrage] = useState("")
    const [decimal, setDecimal] = useState("")
    const anchor = 'bottom'

    let requestDetails = props.field.requestOnline

    useEffect(() => {
        setVolumeFunc()
    }, [])

    const setVolumeFunc = () => {
        if (requestDetails.iVolumeReceived !== 0) {
            let volume = String(requestDetails.iVolumeReceived)
            volume = volume.split('.')
            setLitrage(volume[0])
            if (volume.length === 2) setDecimal(volume[1])
        }
    }

    const setLitrageFunc = (value) => {
        value = value === "" ? "" : parseInt(value)
        if (value >= 0 && value <= 350)
            setLitrage(value)
    }

    const setDecimalFunc = (value) => {
        if (value >= 0 && value <= 99)
            setDecimal(value)
    }

    const getBtnTitle = () => {
        return (
            <>
                <IntlMessages id="recordLiterature" />
                ( {decimal === "" ? "00" : decimal} .  {litrage === "" ? "00" : litrage}  )
            </>
        )
    }

    const volumeReceivedConfirmationFunc = async () => {
        await props.volumeReceivedConfirmationAction(props.vRequestCode, litrage, decimal)
        props.setRefueling()
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.refueling}
                onClose={() => props.setRefueling()}
            >
                <Grid className={classes.root}>
                    <Grid container className={classes.gridTitle}>
                        <Grid item xs={10} md={10}>
                            <Typography variant="h5">
                                <IntlMessages id="pleaseEnterExactrefuelingRate" />
                            </Typography>
                        </Grid>
                        <Grid item xs={2} md={2}
                            onClick={() => props.setRefueling()}
                            className={classes.icon}>
                            <HighlightOff />
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} className={classes.gridLitrage}>
                        <Grid item xs={6} md={6}>
                            <TextField
                                value={decimal}
                                onChange={(e) => setDecimalFunc(e.target.value)}
                                type="tel"
                                label={<IntlMessages id="decimal" />}
                                variant="outlined" />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <TextField
                                value={litrage}
                                onChange={(e) => setLitrageFunc(e.target.value)}
                                autoFocus
                                type="tel"
                                label={<IntlMessages id="litrage" />}
                                variant="outlined" />
                        </Grid>
                    </Grid>
                    <LoadingButton
                        fullWidth
                        onClick={() => volumeReceivedConfirmationFunc()}
                        loading={props.loadingBtn}
                        color="secondary"
                        variant="contained"
                        size='large'
                        startIcon={<LocalGasStation />}>
                        {getBtnTitle()}
                    </LoadingButton>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        field: state.field,
        loadingBtn: state.common.loadingBtn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        volumeReceivedConfirmationAction: (code, litrage, decimal) =>
            dispatch(online.volumeReceivedConfirmationAction(code, litrage, decimal))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecordLiterature)